export default __webpack_public_path__ + "static/media/lightbulb.e317b23a.svg";